import React from 'react';
import { FlameIcon } from 'lucide-react';
import type { MenuCategory } from '../types/menu';
type MenuCategoryBlockProps = {
  category: MenuCategory;
};
export function MenuCategoryBlock({
  category
}: MenuCategoryBlockProps) {
  return <section id={category.id} aria-labelledby={`${category.id}-heading`} className="scroll-mt-32" data-id="element-7" data-mp="2qpy0u7gru8ck">
      <div className="border-b-2 border-verde pb-3" data-id="element-8" data-mp="2lrwf1erynuxe">
        <h3 id={`${category.id}-heading`} className="font-display text-3xl text-verde sm:text-4xl" data-id="element-9" data-mp="2gtuns6kdspau">
          {category.title}
        </h3>
        {category.description && <p className="mt-1 max-w-3xl text-sm italic text-muted sm:text-base" data-id="element-10" data-mp="27sn1kmv53ex4">
            {category.description}
          </p>}
      </div>

      <ul className="mt-6 grid grid-cols-1 gap-x-16 gap-y-5 md:grid-cols-2" data-id="element-11" data-mp="22uvafv2bjwtz">
        {category.items.map(item => <li key={item.name} className="flex flex-col" data-id="element-12" data-mp="60idxnkob3s7">
            <div className="flex items-baseline" data-id="element-13" data-mp="11xc5jprwc1n">
              <h4 className="flex items-center gap-2 text-lg font-bold text-ink" data-id="element-14" data-mp="1042rwnrzdpy">
                {item.name}
                {item.spicy && <FlameIcon className="h-4 w-4 text-salsa" aria-label="Spicy" data-id="element-15" data-mp="39aptb67kekz1" />}
                {item.popular && <span className="rounded-full bg-verde/10 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-verde" data-id="element-16" data-mp="2vc9c2lc2tc2n">
                    Favorito
                  </span>}
              </h4>
              <span className="mx-3 flex-grow translate-y-[-4px] border-b-2 border-dotted border-line" aria-hidden="true" data-id="element-17" data-mp="3o1ghm49y71xe" />
              <span className="whitespace-nowrap text-lg font-bold text-salsa" data-id="element-18" data-mp="3e8r7pdu1pw46">{item.price}</span>
            </div>
            {item.description && <p className="mt-0.5 text-sm leading-relaxed text-muted" data-id="element-19" data-mp="at3rf3k1vfgt">{item.description}</p>}
            {item.options && <p className="mt-1 text-sm font-medium text-verde" data-id="element-20" data-mp="fkc180pal2ui">{item.options}</p>}
          </li>)}
      </ul>

      {category.notices && <div className="mt-6 rounded-xl border-l-4 border-salsa bg-cream px-5 py-4" data-id="element-21" data-mp="kgpirc30z6b0">
          {category.notices.map(n => <p key={n} className="text-sm font-medium text-ink" data-id="element-22" data-mp="fgbl8nz1ver8">
              {n}
            </p>)}
        </div>}
    </section>;
}